import { render } from "./CustomersList.vue?vue&type=template&id=6fde7dca&scoped=true&ts=true"
import script from "./CustomersList.vue?vue&type=script&lang=ts"
export * from "./CustomersList.vue?vue&type=script&lang=ts"

import "./CustomersList.vue?vue&type=style&index=0&id=6fde7dca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fde7dca"]])

export default __exports__